import React from "react";
import AddEditReasonForm from "../reason_form";
import { GeneralModal } from '@rankmi/ats-app'
const ClosingReasonModal = ({ showModal, setShowModal, reasonSelected, onSaveClosingReason }) => {
  return (
    <GeneralModal
      title={reasonSelected ? "Editar motivo" : "Crear nuevo motivo"}
      visible={showModal}
      onClose={() => setShowModal(false)}
    >
      <AddEditReasonForm
        reasonSelected={reasonSelected}
        onSubmit={onSaveClosingReason}
        onCancel={() => setShowModal(false)}
      />
    </GeneralModal>
  );
};

export default ClosingReasonModal;
